import { Chip, CircularProgress, ColorPaletteProp } from '@mui/joy';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { TaskStatus, PriorityValues, PRIORITY_MAP } from './configs';

export function StatusChip({
  status,
  size = 'md',
  count,
}: {
  status: TaskStatus;
  size?: 'sm' | 'md' | 'lg';
  count?: number;
}) {
  const intl = useIntl();
  const taskColors: ColorPaletteProp[] = [
    'neutral',
    'warning',
    'secondary',
    'success',
  ];
  const taskLabels = [
    intl.formatMessage({ defaultMessage: 'To Do' }),
    intl.formatMessage({ defaultMessage: 'In Progress' }),
    intl.formatMessage({ defaultMessage: 'Under Review' }),
    intl.formatMessage({ defaultMessage: 'Completed' }),
  ];
  return (
    <Chip
      size={size}
      sx={{
        paddingX: 1,
        textTransform: 'uppercase',
      }}
      color={taskColors[status]}
    >
      {taskLabels[status]} {count}
    </Chip>
  );
}

export function PriorityChip({ priority }: { priority?: PriorityValues }) {
  const intl = useIntl();

  const priorityColor = PRIORITY_MAP.find(
    (item) => item.name === priority,
  )!.color;

  const taskLabels = {
    Low: intl.formatMessage({ defaultMessage: 'Low' }),
    Medium: intl.formatMessage({ defaultMessage: 'Medium' }),
    High: intl.formatMessage({ defaultMessage: 'High' }),
    Critical: intl.formatMessage({ defaultMessage: 'Critical' }),
    Default: intl.formatMessage({ defaultMessage: 'Default' }),
  };

  return (
    <Chip
      startDecorator={
        <div className={clsx(`${priorityColor} w-2 h-2 rounded-full`)}></div>
      }
      variant='outlined'
    >
      {priority ? taskLabels[priority] : ''}
    </Chip>
  );
}

export function LoadingWrapper({
  children,
  loading,
}: {
  children: ReactNode;
  loading: boolean;
}) {
  return (
    <div className='relative'>
      {children}
      {loading && (
        <div className='absolute top-0 w-full h-full bg-gray-500 bg-opacity-15 flex justify-end p-3'>
          <CircularProgress size='sm' color='secondary'/>
        </div>
      )}
    </div>
  );
}
